<div class="footer block">
  <div class="container">
    <div class="footer__blocks">
      <app-company />
      <app-buy-images />
      <app-free-images />
      <app-download-app />
    </div>
    <div class="down-footer">
      <app-copyrights />
      <!-- <app-select-language /> -->
      <app-payment-types />
    </div>
  </div>
</div>
